import { Dialog, DialogContent } from "@material-ui/core";
import { useSnackbar } from "notistack";
import React, { useEffect } from "react";
import ParkService from "../ParkService";

const PayModal = ({ open, onClose, link, form }) => {
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const handleMessage = async (event) => {
      if (!link) return;
      // if (event.origin !== 'https://tudominio.com') return; // seguridad
      if (!event) return;
      const respuesta = JSON.stringify(event.data);
      const resFormat = respuesta.replace(/\\/g, "");
      const resFormatFinal = resFormat.replace(/"/g, "'");
      resFormatFinal.slice(1, -1);
      const resParsed = event.data;
      if (!resParsed.status) return;
      try {
        if (resParsed.status === "failed" || resParsed.code >= 500) {
          throw Error(resParsed.description);
        }
        await ParkService.postProcessPay({
          id: form.id,
          conjunto: form.conjunto,
          valor: resParsed.detail.amount,
          comprobante: resParsed.detail.id_transaccion,
          usuario: resParsed.detail.clientName,
          dni: resParsed.detail.clientID,
          correo: form.correo,
          portalRes: resFormatFinal,
        });
        enqueueSnackbar("El pago fue realizado con éxito", {
          variant: "success",
        });
        // Here you can set the received URL to state or render it directly using WebView
        onClose();
      } catch (error) {
        enqueueSnackbar(error.message || "Error al realizar el pago", {
          variant: "error",
        });
        onClose();
      }
    };
    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);
  return (
    <div>
      <Dialog
        open={open}
        onClose={onClose}
        fullWidth
        maxWidth="sm"
        scroll="paper"
      >
        <DialogContent dividers>
          <iframe
            src={link}
            width="100%"
            height="600"
            title="Pasarela de Pago"
            allow="*"
          />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default PayModal;
